// extracted by mini-css-extract-plugin
export default {"footer":"footer-TKoT_","modal":"modal-hzjGz","body":"body-_PjMf"};